import { render, staticRenderFns } from "./ReferralPayments.vue?vue&type=template&id=31287eed&"
import script from "./ReferralPayments.vue?vue&type=script&lang=js&"
export * from "./ReferralPayments.vue?vue&type=script&lang=js&"
import style0 from "./ReferralPayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports